import { render } from "./SkillhomeView.vue?vue&type=template&id=4a18a584"
import script from "./SkillhomeView.vue?vue&type=script&lang=js"
export * from "./SkillhomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__